import * as PropTypes from "prop-types"
import styled from "styled-components"
import YoutubeLazy from "components/YoutubeLazy"
import Typography from "components/styled/Typography"
import { Container } from "components/styled/Grid"
import { useT } from "react-polyglot-hooks"
import { useContext } from "react"
import { BrandContext } from "scenes/BrandScene/BrandContext"
import { sendEvent } from "scripts/GoogleAnalytics"

const StyledVideo = styled(YoutubeLazy)`
  width: 720px;
  max-width: 100%;
  padding: 0;
`

const TextContainer = styled(Container)`
  width: 720px;
  max-width: 100%;
  margin: 0 auto;

  @media (min-width: 720px) {
    padding: 0;
  }
`

function Video({ slide: { model, video } }) {
  const { name, seoData, sellingStatus } = useContext(BrandContext)
  const t = useT()

  const shouldUseSeoData = sellingStatus !== "flexible"
  const headerTitle =
    (shouldUseSeoData && seoData?.header_title) ||
    t(`brand.header.${sellingStatus}.title`, { brand: name })

  const handleLoad = () => {
    sendEvent("Video", { event_category: "brand", event_label: "play" })
  }

  return (
    <>
      <StyledVideo autoPlay videoId={video} handleLoad={handleLoad} alt={headerTitle} />
      <TextContainer>
        <Typography weight="bold" css="margin-top: 10px;">
          {model ? t("brand.videos.video_title", { brand: name, model }) : t("brand.videos.video_title_only_brand", { brand: name })}
        </Typography>
      </TextContainer>
    </>
  )
}

Video.propTypes = {
  slide: PropTypes.shape({
    model: PropTypes.string,
    video: PropTypes.string
  }).isRequired
}

export default Video
